import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { ordersBunja } from '@flipster/r230522/original/order';

import { useTimeTriggerTpslBaseInfo } from '@web/features/modals/TimeTriggerTpslModal/useTimeTriggerTpslBaseInfo';
import { useTimeTriggerTpslModal } from '@web/features/modals/TimeTriggerTpslModal/useTimeTriggerTpslModal';

import TriggerPricePosition from './TriggerPricePosition';
import TriggerTimePosition from './TriggerTimePosition';

const PendingPosition = () => {
  const { pendingPositionsAtom } = useBunja(ordersBunja);
  const positions = useAtomValue(pendingPositionsAtom);
  const { tpSlInfo } = useTimeTriggerTpslModal();
  const { symbol } = useTimeTriggerTpslBaseInfo();

  const currentPosition = positions?.[symbol]?.find((p) => p.slot === tpSlInfo?.slot);

  if (!currentPosition?.triggerTimestamp) return <TriggerPricePosition />;

  return <TriggerTimePosition />;
};

export default PendingPosition;
